import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Flags } from 'react-feature-flags'

import IconCheveronUp from '../../img/icon-cheveron-up.svg'
import IconCheveronDown from '../../img/icon-cheveron-down.svg'
import { hotkeys } from '../config'
import PlusMinus from './PlusMinus'
import { logOut as logOutConnect } from '../actions/account'
import { logout } from './Accounts/API'
import { setDialog as setDialogConnect } from '../actions/navigation'

const menuItems = [
    ['overview', 'Overview'],
    ['explore', 'Explore'],
    ['screen', 'Screen'],
    ['analyze', 'Analyze']
]

export class Navigation extends React.Component {
    static propTypes = {
        // parent props
        active: PropTypes.string.isRequired,
        share: PropTypes.bool,
        onMenu: PropTypes.func.isRequired,
        collapsed: PropTypes.bool.isRequired,
        setCollapsed: PropTypes.func.isRequired,
        // redux action
        clearUserDetails: PropTypes.func.isRequired,
        // redux state
        loggedIn: PropTypes.bool.isRequired,
        setDialog: PropTypes.func.isRequired
    }

    static defaultProps = {
        share: false
    }

    constructor(props) {
        super(props)

        this.state = { show: false }
        this.navRef = React.createRef()
    }

    toggleMenu = () => {
        const { show } = this.state
        if (show) {
            this.hideMenu()
        } else {
            this.showMenu()
        }
    }

    showMenu = () => {
        const { show } = this.state

        if (!show) {
            window.document.addEventListener('click', this.onClick)
            this.setState({ show: true })
        }
    }

    hideMenu = () => {
        const { show } = this.state

        if (show) {
            window.document.removeEventListener('click', this.onClick)
            this.setState({ show: false })
        }
    }

    onClick = e => {
        if (this.navRef.current.contains(e.target)) {
            return
        }

        this.hideMenu()
    }

    generateAccountSubmenu() {
        const { loggedIn, clearUserDetails, setDialog } = this.props

        if (!loggedIn) {
            return (
                <>
                    <ul className="account-nav">
                        <li>
                            <button type="button" className="account-nav-button" onClick={() => setDialog('signIn')}>
                                Sign In
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="account-nav-button"
                                onClick={() => setDialog('createAccount')}
                            >
                                Sign Up
                            </button>
                        </li>
                    </ul>
                    <div className="divider" />
                </>
            )
        }
        return (
            <>
                <ul className="account-nav">
                    <li>
                        <button
                            type="button"
                            className="account-nav-button"
                            onClick={() => {
                                logout()
                                clearUserDetails()
                            }}
                        >
                            Sign Out
                        </button>
                    </li>
                </ul>
                <div className="divider" />
            </>
        )
    }

    render() {
        const { active, share, onMenu, collapsed, setCollapsed, setDialog } = this.props
        const { show } = this.state

        const [activeLabel] = menuItems.find(item => item[0] === active)

        return (
            <>
                <div className="mobile-menu" aria-hidden="true">
                    <div className="overview-toggle" aria-hidden="true">
                        <button onClick={this.toggleMenu}>
                            {share ? 'Create Link' : activeLabel}{' '}
                            <span className="svg-icon icon-16 mobile-menu-button" style={{ marginRight: '15px' }}>
                                {show ? <IconCheveronUp /> : <IconCheveronDown />}
                            </span>
                        </button>
                    </div>

                    <div className="content-toggle" aria-hidden="true">
                        <button
                            className={`content-toggle-btn ${collapsed ? 'collapsed' : ''}`}
                            onClick={() => setCollapsed(!collapsed)}
                            title={`${collapsed ? 'Expand' : 'Collapse'} (Space)`}
                        >
                            <span className="is-hidden-touch">{collapsed ? 'Expand' : 'Collapse'}</span>
                            <span className="is-hidden-desktop">Map</span>

                            <PlusMinus inverted />
                        </button>
                    </div>
                </div>
                <div className={`scrim ${show ? 'fade-in' : 'fade-out'}`} />
                <nav className={`nav ${show ? 'fade-in' : 'fade-out'}`} ref={this.navRef}>
                    <ul className="center-nav">
                        {menuItems.map(([name, label]) => (
                            <li className={name === active && !share ? 'active' : ''} key={name}>
                                <button
                                    onClick={() => {
                                        onMenu(name)
                                        this.hideMenu()
                                    }}
                                    title={`${label} (${hotkeys.navigation[name].toUpperCase()})`}
                                >
                                    {label}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div className="divider" />
                    {this.generateAccountSubmenu()}
                    <ul className="right-nav">
                        <li>
                            <a href="http://opr.ca.gov">OPR Home</a>
                        </li>
                        <li>
                            <button onClick={() => setDialog('about')}>About</button>
                        </li>
                        <li className={share ? 'active' : ''}>
                            <button
                                onClick={() => {
                                    onMenu('share')
                                    this.hideMenu()
                                }}
                            >
                                Create Link
                            </button>
                        </li>
                        <li>
                            <button onClick={() => setDialog('methods')}>Methods</button>
                        </li>
                        <li>
                            <button onClick={() => setDialog('other')}>Other Resources</button>
                        </li>
                    </ul>
                </nav>
            </>
        )
    }
}

export default connect(
    ({ account: { email } }) => ({ loggedIn: !!email }),
    dispatch => ({
        clearUserDetails: () => dispatch(logOutConnect()),
        setDialog: dialogName => dispatch(setDialogConnect(dialogName))
    })
)(Navigation)
